import { useState } from "react";
import en from "../i18n/en";
import { LanguageCode } from "../types";

export type Translation = typeof en;
export type TranslationKeys = keyof Translation;

export const ts: { [key in LanguageCode]: Translation } = {
  en,
};

export type I18n = {
  translation: Translation;
  errorsMap: Map<number, string>;
};

const useI18n = (): I18n => {
  const [translation] = useState<Translation>(en);

  //   useEffect(() => {
  //     auth.identity?.language && setTranslation(ts[auth.identity.language] ?? en);
  //   }, [auth.identity?.language]);

  const errorsMap = new Map<number, string>([
    // [100007, translation.drivers.errors.rothoblaasUserNotFound],
  ]);

  return { translation: translation, errorsMap };
};

export default useI18n;
